<template>
  <div>
    <div class="loader" v-if="assetId !== null && asset === null" style="z-index: 99"></div>
    <modalWindow
      v-if="asset !== null"
      @close="closeAsset"
      width="860"
      position="edge"
      class="fds"
    >
      <div class="titlebar">
        {{ asset.name == "COUPON" ? "Opgelopen Rente" : asset.name }}
      </div>
      <div class="viewport">
        <div class="inset">
          <h3>{{ asset.friendly_name }}</h3>
        </div>
        <div class="fds-container">
          <div class="fds-box" title="Toon extra info" @click="openModal('aantal')">
            Aantal
            <p class="graphTextStyle">
              <span v-if="$parent.positions[assetId].obli">{{ asset.currency }}</span>
              {{
                formatPrice(
                  $parent.positions[assetId].obli
                    ? $parent.positions[assetId].quantity * 100
                    : $parent.positions[assetId].quantity,
                    $parent.positions[assetId].quantity % 1 === 0,
                    $parent.positions[assetId].original_class == "Valutas"
                      || $parent.positions[assetId].original_class == "Coupons" ? 2 : 4
                )
              }}
            </p>
          </div>
          <div class="fds-box" title="Toon extra info" @click="openModal('koers')">
            Koers
            <p
              v-if="$parent.positions[assetId].obli"
              class="graphTextStyle"
              style="margin-top:10%;"
            >
              {{formatPrice(
                $parent.positions[assetId].rate / $parent.positions[assetId].currency_rate
              )}}%
            </p>
            <p
              v-else-if="asset.currency !== 'EU'"
              class="graphTextStyle"
              style="margin-top:10%;"
            >
              &euro;&nbsp;{{formatPrice($parent.positions[assetId].rate)}} <br/>
              ({{asset.currency}}&nbsp;{{
                formatPrice($parent.positions[assetId].rate
                / $parent.positions[assetId].currency_rate)
              }})
            </p>
            <p v-else class="graphTextStyle" style="margin-top:10%;">
                &euro;&nbsp;{{formatPrice($parent.positions[assetId].rate)}}
            </p>
          </div>
          <div class="fds-box" title="Toon extra info" @click="openModal('waarde')">
            Waarde
            <div v-if="asset.currency !== 'EU'">
              <p class="graphTextStyle" style="margin-top:10%;">
                &euro;&nbsp;{{formatPrice($parent.positions[assetId].worth)}} <br/>
                ({{asset.currency}}&nbsp;{{
                  formatPrice($parent.positions[assetId].worth
                  / $parent.positions[assetId].currency_rate)
                }})
              </p>
            </div>
            <p v-else  class="graphTextStyle"  style="margin-top:10%;">
              &euro;&nbsp; {{ formatPrice($parent.positions[assetId].worth) }}
            </p>
          </div>
          <div
            class="fds-box"
            title="Toon extra info"
            style="background:lightgray;"
            @click="openModal('valuta')"
          >
            Valuta
            <p class="graphTextStyle" style="margin-top: 10%;">
              {{ asset.currency }}
            </p>
          </div>
          <div class="fds-box" title="Toon extra info" @click="openModal('aanschafwaarde')">
            Aanschafwaarde
            <p class="graphTextStyle" style="margin-top: 10%;">
              &euro;&nbsp; {{ formatPrice($parent.positions[assetId].purchaseCost) }}
            </p>
          </div>
          <div class="fds-box" title="Toon extra info" @click="openModal('aankoopkoers')">
            Aankoopkoers
            <p
              v-if="$parent.positions[assetId].obli"
              class="graphTextStyle"
              style="margin-top:10%;"
            >
              {{formatPrice($parent.positions[assetId].purchase_rate)}}%
            </p>
            <p v-else class="graphTextStyle" style="margin-top: 10%;">
              &euro;&nbsp;
              {{ formatPrice($parent.positions[assetId].purchase_rate) }}
            </p>
          </div>
          <div class="fds-box" title="Toon extra info" @click="openModal('resultaat')">
            Resultaat
            <p
              class="graphTextStyle"
              :style="`color :${Number($parent.positions[assetId].result) > 0 ? 'green' : 'red'}`"
              style="margin-top: 10%;"
            >
              &euro;&nbsp; {{ formatPrice($parent.positions[assetId].result) }}
            </p>
          </div>
          <div class="fds-box" title="Toon extra info" @click="openModal('rendement')">
            Rendement
            <p
                class="graphTextStyle"
              :style="`color :${Number(
                (($parent.positions[assetId].worth - $parent.positions[assetId].purchaseCost)
                / Math.abs($parent.positions[assetId].purchaseCost)) * 100) > 0 ? 'green' : 'red'}`"
              style="margin-top: 10%;"
            >
              {{
                formatPrice(
                  (($parent.positions[assetId].worth - $parent.positions[assetId].purchaseCost) /
                    Math.abs($parent.positions[assetId].purchaseCost)) *
                    100
                )
              }}%
            </p>
          </div>
          <div
            class="fds-box"
            title="Toon extra info"
            @click="openModal('rendementYTD')"
            v-if="(filter(rates, {date: `${new Date().getFullYear()}-01-01`}).length > 0)
              && (rates[rates.length - 1].rate - filter(
                rates, {date: `${new Date().getFullYear()}-01-01`}
                )[0].rate > 0)"
          >
            Rendement YTD
            <p
              :style="`color :${Number(
                ((rates[rates.length - 1].rate - filter(
                    rates, {date: `${new Date().getFullYear()}-01-01`}
                  )[0].rate)
                ) * 100) > 0 ? 'green' : 'red'}`"
              class="graphTextStyle"
              style="margin-top: 10%;"
            >
              {{formatPrice(
                (
                  (rates[rates.length - 1].rate - filter(
                    rates, {date: `${new Date().getFullYear()}-01-01`}
                  )[0].rate)
                  / filter(
                    rates, {date: `${new Date().getFullYear()}-01-01`}
                  )[0].rate) * 100)
              }}%
            </p>
          </div>
          <div
            class="fds-box"
            title="Toon extra info"
            @click="openModal('type')"
            style="background:lightgray;"
          >
            Type
            <p class="graphTextStyle" style="margin-top: 10%;">
              {{ asset.class }}
            </p>
          </div>
          <div
            v-if="asset.sustainable_score"
            class="fds-box"
            title="Toon extra info"
            style="background: lightgray;"
            @click="openModal('duurzaam')"
          >
            Duurzaamheid volgens<br/> Morningstar
            <p
              class="graphTextStyle" style="margin-top:10%;font-size: large"
              :title="`${asset.sustainable_score} / 50`"
              :style="`color: ${this.$store.state.colorScheme[3]}`"
            >

              <awesomeIcon
                icon="star" v-if="asset.sustainable_score < 45"
              />
              <awesomeIcon
                icon="star-half-alt"
                v-else
              />

              <awesomeIcon
                icon="star" v-if="asset.sustainable_score < 35"
              />
              <awesomeIcon
                icon="star-half-alt"
                v-else-if="asset.sustainable_score < 40"
              />
              <awesomeIcon
                icon="fa-regular fa-star"
                v-else
              />

              <awesomeIcon
                icon="star" v-if="asset.sustainable_score < 25"
              />
              <awesomeIcon
                icon="star-half-alt"
                v-else-if="asset.sustainable_score < 30"
              />
              <awesomeIcon
                icon="fa-regular fa-star"
                v-else
              />

              <awesomeIcon
                icon="star" v-if="asset.sustainable_score < 15"
              />
              <awesomeIcon
                icon="star-half-alt"
                v-else-if="asset.sustainable_score < 20"
              />
              <awesomeIcon
                icon="fa-regular fa-star"
                v-else
              />
              <awesomeIcon
                icon="star" v-if="asset.sustainable_score < 5"
              />
              <awesomeIcon
                icon="star-half-alt"
                v-else-if="asset.sustainable_score < 10"
              />
              <awesomeIcon
                icon="fa-regular fa-star"
                v-else
              />
            </p>
          </div>
          <div
            class="fds-box"
            title="Toon extra info"
            @click="openModal('weging')"
            style="background:lightgray;"
          >
            Weging
            <p class="graphTextStyle" style="margin-top:10%;">
              {{ formatPrice(($parent.positions[assetId].worth * 100) / total) }}%
            </p>
          </div>
        </div>

        <div class="block">
          <div style="display:flex; flex-direction:row-reverse;">
            <div class="dropdown nowrap">
              <button
                class="dropdown-button"
                @click="dropdownlist3 = !dropdownlist3"
                >
                {{filterOptionSelected}} <awesomeIcon icon="caret-down" style="color:black;"/>
              </button>
              <div
                class="dropdown-bg"
                v-if="dropdownlist3"
                @click="dropdownlist3 = !dropdownlist3"
              >
              </div>
              <ul class="dropdown-list" v-if="dropdownlist3">
                <li
                  v-for="(filter, index) in filterOptions" :key="index"
                  @click="dropdownlist3 = !dropdownlist3; filterOptionSelected = filter;"
                >
                  {{filter}}
                </li>
                <li
                  class="dropdown-cancel"
                  @click="dropdownlist3 = !dropdownlist3"
                >
                  Annuleren
                </li>
              </ul>
            </div>
            <div class="dropdown nowrap" style="margin-right:10px;" v-if="graphOptions.length > 1">
              <button
                class="dropdown-button"
                @click="dropdownlist4 = !dropdownlist4"
                >
                <awesomeIcon class="hide-mobile" icon="chart-area"/>
                {{graphOptionSelected}} <awesomeIcon icon="caret-down" style="color: black;"/>
              </button>
              <div
                class="dropdown-bg"
                v-if="dropdownlist4"
                @click="dropdownlist4 = !dropdownlist4"
              >
              </div>
              <ul class="dropdown-list" v-if="dropdownlist4">
                <li
                  v-for="(filter, index) in graphOptions" :key="index"
                  @click="dropdownlist4 = !dropdownlist4; graphOptionSelected = filter;"
                >
                  {{filter}}
                </li>
                <li
                  class="dropdown-cancel"
                  @click="dropdownlist4 = !dropdownlist4"
                >
                  Annuleren
                </li>
              </ul>
            </div>
          </div>
          <div class="card-graph">
            <GChart
              :settings="{ packages: ['corechart'], language: 'nl-nl' }"
              :data="graphPositions"
              :options="getOptions"
              type="ComboChart"
            />
          </div>
        </div>

        <div v-if="asset.description || asset.link" class="block">
          <template v-if="asset.description">
            <h3>Over '{{asset.friendly_name ? asset.friendly_name : asset.name }}'</h3>
            <p>{{ asset.description }}</p>
          </template>
          <template v-if="asset.link">
            <i>
              Voor meer informatie, ga naar <a :href="asset.link" target="_blank">{{asset.link}}</a>
            </i>
          </template>
        </div>

        <template v-if="transactions !== null">
          <div v-if="transactions.length == 0" class="msg">
            <awesomeIcon icon="exclamation-circle" /> Nog geen transacties!
          </div>
          <div v-else class="block">
            <h3>Mutaties (sinds 01-01-2015)</h3>
            <div class="scroll-container">
              <table class="new">
                <tr>
                  <th width="100">Datum</th>
                  <th width="150">Soort transactie</th>
                  <th width="80" style="text-align: left;" class="number">Aantal</th>
                  <th width="80" style="text-align: left;" class="number">Koers</th>
                  <th width="80" style="text-align: left;" class="number">Waarde</th>
                  <th width="80" style="text-align: left;" class="number">Resultaat</th>
                </tr>
                <tr
                  v-for="transaction in transactions.slice(
                    currentPage * resultsPerPage, (
                      currentPage + 1
                    ) * resultsPerPage
                  )"
                  :key="transaction.id"
                >
                  <td>
                    {{ new Date(transaction.date).toLocaleDateString() }}
                  </td>
                  <td>{{ transaction.class }}</td>
                  <td v-if="transaction.class == 'Rente'">&nbsp;</td>
                  <td v-else>
                    {{ transaction.quantity }}
                  </td>
                  <td v-if="transaction.class == 'Rente'">&nbsp;</td>
                  <td v-else-if="!$parent.positions[assetId].obli">
                    &euro; {{ formatPrice(transaction.rate) }}
                  </td>
                  <td v-else>
                    {{ formatPrice(transaction.rate) }}%
                  </td>
                  <td>
                    &euro; {{ formatPrice(transaction.total) }}
                  </td>
                  <td>
                    {{
                      transaction.class == 'Verkoop'
                      ? (transaction.result > 0
                        ? '+'
                        : '')
                      + formatPrice(transaction.result)
                      : '-'
                    }}
                  </td>
                </tr>
              </table>
            </div>
            <pagerElement
              v-model="currentPage"
              :records="transactions.length"
              :resultsPerPage="resultsPerPage"
            />
          </div>
        </template>

      </div>

      <modalWindow v-if="infoModal" @close="infoModal = false">
        <div class="titlebar">{{ infoText.header }}</div>
        <div class="inset" v-html="infoText.text"/>
      </modalWindow>

    </modalWindow>
  </div>
</template>
<script>
import {
  sumBy,
  findIndex,
  filter,
} from 'lodash-es';

export default {
  name: 'FundDetailScreen',
  data() {
    return {
      assetId: null,
      dropdownlist3: false,
      dropdownlist4: false,
      transactions: null,
      asset: null,
      rateRows: [],
      positionRows: [],
      rates: null,
      currentPage: 0,
      resultsPerPage: 5,
      infoModal: false,
      infoText: {},
      graphOptionSelected: 'Koersverloop',
      graphOptions: [
        'Koersverloop',
      ],
      filterOptionSelected: '1 maand',
      filterOptions: ['1 maand', '6 maanden', '1 jaar', 'YTD', '5 jaar', 'Alles'],
    };
  },
  watch: {
    assetId() {
      if (this.assetId !== null) {
        this.graphOptionSelected = 'Koersverloop';
        this.posDetails();
      }
    },
  },
  computed: {
    rateColumns() {
      return [
        {
          type: 'date',
          label: 'Datum',
        },
        {
          type: 'number',
          label: 'Koers',
        },
        {
          type: 'string',
          role: this.filterOptionSelected === '1 maand' ? 'annotation' : 'tooltip',
        },
        {
          type: 'string',
          role: 'style',
        },
      ];
    },
    positionColumns() {
      return [
        {
          type: 'date',
          label: 'Datum',
        },
        {
          type: 'number',
          label: 'Positie',
        },
        {
          type: 'string',
          role: this.filterOptionSelected === '1 maand' ? 'annotation' : 'tooltip',
        },
        {
          type: 'string',
          role: 'style',
        },
      ];
    },
    total() {
      return sumBy(this.$parent.positions, 'worth');
    },
    currentPort() {
      return this.$parent.currentPort;
    },
    getOptions() {
      const options = {
        pointSize: 1,
        backgroundColor: { fill: 'transparent' },
        height: 300,
        colors: this.$store.state.colorScheme,
        legend: {
          position: 'none',
        },
        explorer: {
          axis: 'horizontal',
          keepInBounds: true,
          maxZoomIn: 4.0,
          maxZoomOut: 1.0,
        },
        chartArea: {
          left: 65,
          top: 25,
          bottom: 30,
          right: 20,
          width: '100%',
          height: '100%',
        },
        hAxis: {
          // format: 'short',
          textStyle: { fontSize: 12 },
        },
        vAxis: {
          format: this.getFormatYaxis,
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 12 },
        },
        seriesType: 'area',
        series: {
          0: {
            type: 'line',
            color: '#000',
          },
        },
      };
      return options;
    },
    getFormatYaxis() {
      if (this.$parent.positions[this.assetId].obli) {
        return '#';
      }
      if (this.graphOptionSelected === 'Koersverloop') {
        return '€#';
      }
      return `${this.asset.currency}#`;
    },
    getPositionRows() {
      const newRateArray = [];
      let element = [];
      for (let i = 0; i < this.positionRows.length; i += 1) {
        element = Object.values(this.positionRows[i]);
        newRateArray.push(element);
      }
      return newRateArray;
    },
    getRateRows() {
      const newRateArray = [];
      let element = [];
      for (let i = 0; i < this.rateRows.length; i += 1) {
        element = Object.values(this.rateRows[i]);
        newRateArray.push(element);
      }
      return newRateArray;
    },
    graphPositions() {
      let dayCount = 1;
      if (this.filterOptionSelected === '1 maand') {
        dayCount = 30;
      } else if (this.filterOptionSelected === '6 maanden') {
        dayCount = 180;
      } else if (this.filterOptionSelected === '1 jaar') {
        dayCount = 365;
      } else if (this.filterOptionSelected === '5 jaar') {
        dayCount = 1825;
      }
      let dayFilter = new Date();
      let filterData = [];
      if (this.filterOptionSelected === 'YTD') {
        dayFilter = new Date(`${new Date().getFullYear()}-01-01`);
      }
      dayFilter.setDate(dayFilter.getDate() - dayCount);
      if (this.graphOptionSelected === 'Koersverloop') {
        // Selected graph is Rates
        filterData = this.filterOptionSelected !== 'Alles'
          ? [this.rateColumns].concat(filter(
            this.getRateRows,
            (o) => o[0] > dayFilter,
          ))
          : [this.rateColumns].concat(this.getRateRows);
      } else {
        // Selected graph is positions
        filterData = this.filterOptionSelected !== 'Alles'
          ? [this.positionColumns].concat(filter(
            this.getPositionRows,
            (o) => o[0] > dayFilter,
          ))
          : [this.positionColumns].concat(this.getPositionRows);
      }
      return filterData;
    },
  },
  methods: {
    filter,
    openModal(type) {
      if (type === 'aantal') {
        this.infoText = {
          header: 'Aantal',
          text: `Aantal stukken per belegging, eventueel afgerond op 4 cijfers achter de komma. Bij
          obligaties wordt het aantal aangeduid als het uitgeleende bedrag.`,
        };
      } else if (type === 'koers') {
        this.infoText = {
          header: 'Koers',
          text: `De waarde van de belegging per stuk in de getoonde valuta. Deze koers is de
          slotprijs van de voorgaande handelsdag. Bij obligaties wordt de waarde aangeduid als een
          percentage.`,
        };
      } else if (type === 'waarde') {
        this.infoText = {
          header: 'Waarde',
          text: `De waarde die u hier ziet is de huidige waarde van de belegging. Dit is het aantal
          x de huidig koers. De koers is de slotprijs van de voorgaande handelsdag.`,
        };
      } else if (type === 'valuta') {
        this.infoText = {
          header: 'Valuta',
          text: `De valuta waarin de koers van de belegging is genoteerd. Als je op de valuta wijst
          kunt u de gebruikte wisselkoers inzien. De wisselkoers wordt een keer per dag geüpdatet.`,
        };
      } else if (type === 'aanschafwaarde') {
        this.infoText = {
          header: 'Aanschafwaarde',
          text: `De waarde die u hier ziet is de som van waarden van alle losse aan- en verkopen in
          de betreffende belegging.<br /><br /> Bijvoorbeeld: koop (100 x 5 euro) +  koop (200 x 2
          euro) + verkoop (-100 x 3 euro) = 500 + 400 - 300 = 600 euro.`,
        };
      } else if (type === 'aankoopkoers') {
        this.infoText = {
          header: 'Aankoopkoers',
          text: `De waarde die u hier ziet, is de gewogen gemiddelde koers van alle aankopen in de
          betreffende belegging.`,
        };
      } else if (type === 'resultaat') {
        this.infoText = {
          header: 'Resultaat',
          text: `De waarde die u hier ziet, is het verschil tussen de gemiddelde aanschafwaarde en
          de huidige waarde van de betreffende belegging.<br /><br />In dit resultaat zit niet het
          gerealiseerde resultaat van eventuele verkopen die hebben plaatsgevonden. Voor het
          totaalresultaat van uw portefeuille verwijzen wij u naar de rapportages.`,
        };
      } else if (type === 'rendement') {
        this.infoText = {
          header: 'Rendement',
          text: `De waarde die u hier ziet, is de gemaakte winst (of verlies) sinds de aankoop van
          de betreffende belegging tot vandaag in procenten.`,
        };
      } else if (type === 'rendementYTD') {
        this.infoText = {
          header: 'Rendement YTD',
          text: `De waarde die u hier ziet, is de gemaakte winst (of verlies) sinds het begin van
          dit jaar van de betreffende belegging tot vandaag in procenten.`,
        };
      } else if (type === 'type') {
        this.infoText = {
          header: 'Type',
          text: 'Hier wordt de beleggingscategorie getoond van de betreffende belegging.',
        };
      } else if (type === 'duurzaam') {
        this.infoText = {
          header: 'Duurzaamheidsscore',
          text: `<b>De duurzaamheidsscore namens Morningstar van dit fonds is:
            ${this.asset.sustainable_score / 50}.</b><br/><br/>
            De Morningstar Sustainability Rating is een maatstaf voor hoe goed de bedrijven
            waarin een fonds belegt, omgaan met hun ESG (Environmental, Social, Governance)
            risico’s en kansen. We gebruiken ESG-data op bedrijfsniveau van Sustainalytics, een
            toonaangevende aanbieder van ESG ratings en onderzoek, om onze ESG Rating te
            berekenen. Alle fondsen die ten minste 50 procent van hun vermogen hebben belegd in
            bedrijven die een ESG-rating van Sustainalytics hebben, krijgen van Morningstar een
            rating waarbij geldt dat 50 laag is en 0 goed.
            <br/><br/>
            <i>Bron:
              <a
                target="_blank"
                href="https://www.morningstar.nl/nl/news/148035/de-morningstar-sustainability-rating-een-nieuw-perspectief-voor-beleggers.aspx"
              >
                De morningstar Sustainability Rating: een nieuw perspectief voor beleggers
              </a>
            </i>
          `,
        };
      } else {
        this.infoText = {
          header: 'Weging',
          text: `Het percentage dat u hier ziet geeft aan hoeveel procent van de totale portefeuille
          is belegd in de betreffende belegging.`,
        };
      }
      this.infoModal = true;
    },
    closeAsset() {
      this.asset = null;
      this.assetId = null;
      this.infoModal = false;
    },
    posDetails() {
      this.sdk.getPortAsset(
        this.$store.state.currentPort,
        this.$parent.positions[this.assetId].id,
        (response) => {
          this.transactions = response.data.mutations;
          // Graph rows set-up
          this.rateRows = [];
          this.positionRows = [];
          for (let i = 0; i < response.data.rates.length; i += 1) {
            const rateObject = {};
            rateObject.date = new Date(response.data.rates[i].date);
            rateObject.rate = response.data.rates[i].rate;
            const aantalMutaties = sumBy(filter(response.data.mutations, { date: response.data.rates[i].date }), (o) => { if (o.class === 'Verkoop') { return -o.quantity; } if (o.class === 'Aankoop') { return o.quantity; } return 0; });
            if (aantalMutaties !== 0) {
              rateObject.mutation = `${aantalMutaties > 0 ? '+' : ''}${this.formatPrice(
                this.$parent.positions[this.assetId].obli
                  ? aantalMutaties * 100
                  : aantalMutaties,
                aantalMutaties % 1 === 0,
                this.$parent.positions[this.assetId].original_class === 'Valutas'
                || this.$parent.positions[this.assetId].original_class === 'Coupons'
                  ? 2
                  : 4,
              )}`;
              rateObject.style = `point {
                size: 7;
                fill-color: ${aantalMutaties < 0 ? 'red' : 'green'}`;
            } else {
              rateObject.mutation = null;
              rateObject.style = null;
            }
            this.rateRows.push(rateObject);
          }
          for (let i = 0; i < response.data.rates.length; i += 1) {
            if (findIndex(
              response.data.exchangeRates,
              (o) => o.date === response.data.rates[i].date,
            ) !== -1) {
              const positionObject = {};
              positionObject.date = new Date(response.data.rates[i].date);
              positionObject.quantity = Number(response.data.rates[i].rate)
                / Number(response.data.exchangeRates[
                  findIndex(
                    response.data.exchangeRates,
                    (o) => o.date === response.data.rates[i].date,
                  )
                ].rate);
              // if (this.$parent.positions[this.assetId].obli) {
              //   positionObject.quantity /= 100;
              // }
              const aantalMutaties = sumBy(filter(response.data.mutations, { date: response.data.rates[i].date }), (o) => { if (o.class === 'Verkoop') { return -o.quantity; } if (o.class === 'Aankoop') { return o.quantity; } return 0; });
              if (aantalMutaties !== 0) {
                positionObject.mutation = `${aantalMutaties > 0 ? '+' : ''}${this.formatPrice(
                  this.$parent.positions[this.assetId].obli
                    ? aantalMutaties * 100
                    : aantalMutaties,
                  aantalMutaties % 1 === 0,
                  this.$parent.positions[this.assetId].original_class === 'Valutas'
                  || this.$parent.positions[this.assetId].original_class === 'Coupons'
                    ? 2
                    : 4,
                )}`;
                positionObject.style = `point {
                  size: 7;
                  fill-color: ${aantalMutaties < 0 ? 'red' : 'green'}`;
              } else {
                positionObject.mutation = null;
                positionObject.style = null;
              }
              this.positionRows.push(positionObject);
            }
          }
          if (this.$parent.positions[this.assetId].obli) {
            this.rateRows = this.positionRows;
          }

          this.rates = response.data.rates;
          this.currentPage = 0;
          this.asset = response.data.asset;
          if (this.asset.currency !== 'EU' && !this.$parent.positions[this.assetId].obli) {
            this.graphOptions = [
              'Koersverloop',
              `Koersverloop (${this.asset.currency})`,
            ];
          } else {
            this.graphOptions = [
              'Koersverloop',
            ];
          }
        },
      );
    },
  },
};
</script>
<style lang="scss" scoped>

.fds {
  .card-graph {
    padding-bottom: 10px;
    min-height: 300px;
  }
  .fds-container {
    display: flex;
    flex-flow: wrap;
    justify-content: center;
    > * {
      flex-grow: 1;
    }
  }
  .fds-box {
    position: relative;
    background: #fff;
    border-radius: 4px;
    margin: 10px;
    font-size: 10px;
    padding-top: 10px;
    text-align: center;
    cursor: pointer;
  }
  .block {
    background-color: #fff;
    border-radius: 4px;
    margin: 10px;
    padding: 20px;
  }
  .pagebar {
    background-color: transparent;
    border: none;
  }
  .scroll-container {
    width: 100%;
    overflow: auto;
  }
  .viewport {
    padding: 1%;
    bottom: 0;
    top: 52px;
    @media #{$mobile} {
      top: 72px;
    }
  }
}
@media #{$desktop} {
  .fds-box {
    width: 20%;
  }
  .fds-box:hover {
    filter: brightness(90%);
  }
  .graphTextStyle {
    font-size: 17px;
  }
}
@media #{$mobile} {
  .fds-box {
    width: 35%;
  }
  .graphTextStyle {
    white-space: nowrap;
    font-size: 14px;
  }
}
</style>
